<script setup lang="ts">
import ChapterLongQuestionsPage from "~/features/computer/components/ChapterLongQuestionsPage.vue";
</script>

<template>
  <ChapterLongQuestionsPage unit="algorithm" />
</template>
